import LevelDataController from './LevelDataController';
import ScrollingTiledSprites from './ScrollingTiledSprites';

import Row from 'app/game/display/Row';
import RowDashers from 'app/game/display/RowDashers';
import RowShelves from 'app/game/display/RowShelves';
import ShopEnd from 'app/game/display/ShopEnd';
import { GAME_END_HEIGHT, GAME_LANE_HEIGHT, GAME_ROAD_HEIGHT } from '../../constants/AppConstants';

const RANDOM_ITEMS = ['balls', 'cap', 'flowerpot', 'phone', 'sock'];
const SHELF_GROUPS = [['shelf_3_3', 'shelf_3_1', 'shelf_3_6'], ['shelf_3_7', 'shelf_3_9', 'shelf_3_5'], ['shelf_3_8', 'shelf_3_4', 'shelf_3_2']];
export default class MapController extends Phaser.Group {
  /*
  ====================================================================================
    INIT
  ====================================================================================
  */
  constructor({ game, levelData, playerLevel }) {
    super(game);
    this.game = game;
    // grab the data required
    this.levelData = { ...levelData };
    this.playerLevel = playerLevel;
    this.randomItems = Phaser.ArrayUtils.shuffle([...RANDOM_ITEMS]);

    this.rows = [];

    this.fastLaneCount = this.levelData.fastLaneCount;
    this.fastLanesSpawned = 0;

    this.createLevel();

    //pd this.startRoad = this.game.make.sprite(0, 0, 'road_start');
    //pd this.startRoad.position.set(0, game.sceneHeight - this.startRoad.height);

    // this.roadLanes = this.game.make.tileSprite(0, GAME_END_HEIGHT, this.game.defaultWidth, this.game.sceneHeight - 120, 'road_lane_tile');
    //pd this.roadLanes = this.game.make.sprite(0, 0, 'road_lane_tile');

    this.createTiles();

    // this.addChild(this.roadLanes);

    //pd this.addChild(this.startRoad);

    this.endRoad = new ShopEnd(this.game);
    this.addChild(this.endRoad);

    this.addChild(this.laneContainer);

    this.objects = this.game.make.group();
    this.objects.addMultiple(this.rows);
    //this.addChild(this.objects);

    this.updateSorting();
  }

  /*
  ====================================================================================
   MAP CREATION
  ====================================================================================
  */
  createTiles() {
    let startY = GAME_END_HEIGHT;
    this.laneContainer = this.game.make.group();
    for (let yInd = startY; yInd < this.game.sceneHeight - 120; yInd += GAME_ROAD_HEIGHT) {
      let tile = this.game.make.sprite(0, yInd, 'shop_row');
      this.laneContainer.add(tile);
    }
  }

  createLevel() {
    this.createRows();
    /*
     * Add Random Objects
     */
    for (const row of this.rows) {
      if (row instanceof RowShelves) {
        if (Math.random() > 0.5) {
          Phaser.ArrayUtils.rotateRight(this.randomItems);
          const item = this.randomItems[0];
          row.addRandomItem(item);
        }
      }
    }
  }

  createRows() {
    const pattern = [1, 2, 1];
    let dasherType = this.playerLevel % 4;
    for (let index = 0; index < this.levelData.laneCount + 1; index++) {
      let row;
      const sg = index % 3;

      const shelfGroup = Phaser.ArrayUtils.shuffle([...SHELF_GROUPS[sg]]);
      // console.log('shelfGroup', shelfGroup);

      if (index == this.levelData.laneCount || index == 0) {
        // last row - add empty
        row = new Row({
          game: this.game,
          rowNum: index,
        });
      } else if (index % 2 === 0) {
        // add row with shelves and obstacles
        row = new RowShelves({
          game: this.game,
          rowNum: index,
          shelfGroup,
        });
      } else {
        // add row with dashers
        let ind = ((index - 1) / 2) % 3;
        let dashers = pattern[ind];
        if (this.fastLanesSpawned < this.fastLaneCount && dashers == 1) {
          // fast row
          //Get a random value and spawn if greater than a 3 (70% chance)
          let rand = this.game.rnd.integerInRange(0, 10);
          if (rand > 3) {
            let row = new RowDashers({
              game: this.game,
              rowNum: index,
              dasherCount: dashers,
              minMoveSpeed: this.levelData.fastLaneMinSpeed,
              maxMoveSpeed: this.levelData.fastLaneMaxSpeed,
              vehicleVariations: this.levelData.vehicleVariations,
              dasherType: dasherType,
            });
            this.rows.push(row);
            this.fastLanesSpawned++;
            dasherType = (dasherType + dashers) % 4;
            continue;
          }
        }

        // add normal row with dashers
        row = new RowDashers({
          game: this.game,
          rowNum: index,
          dasherCount: dashers,
          minMoveSpeed: this.levelData.minMoveSpeed,
          maxMoveSpeed: this.levelData.maxMoveSpeed,
          vehicleVariations: this.levelData.vehicleVariations,
          dasherType: dasherType,
        });
        dasherType = (dasherType + dashers) % 4;
      }
      this.rows.push(row);
    }
  }

  /*
  ====================================================================================
    UPDATE
  ====================================================================================
  */

  updateMap(timeStep) {
    this.rows.forEach((element) => {
      element.step(timeStep);
    });
  }

  stopAnimations() {
    this.rows.forEach((element) => {
      element.stopAnims();
    });
  }

  startAnimations() {
    this.rows.forEach((element) => {
      element.startAnims();
    });
  }

  updateSorting() {
    this.objects.sort('y', Phaser.Group.SORT_ASCENDING);
  }

  /*
  ====================================================================================
    GET
  ====================================================================================
  */

  getRowPosY(rowNum) {
    return this.rows[rowNum].rowPosY;
  }

  gridToPos(x, y) {
    return this.rows[y].gridToPos(x);
  }

  gridToPosMiddle(y) {
    return this.rows[y].gridPosMiddle();
  }

  getMidGrid(y) {
    return this.rows[y].getMidGrid();
  }

  canGoto(x, y) {
    let value = this.rows[y].cells[x];
    return value != 1;
  }

  getColliders(y) {
    let colliders = this.rows[y].getColliders();
    if (y < this.rows.length - 1) {
      colliders = colliders.concat(this.rows[y + 1].getColliders());
    }
    return colliders;
  }

  /*
  ====================================================================================
    SHUTDOWN
  ====================================================================================
  */
  destroy() {
    this.rows.forEach((element) => {
      element.destroy(true);
    });
    this.rows = null;

    this.laneContainer.destroy(true);
    this.endRoad.destroy();

    super.destroy();
  }
}
